<template>
  <div>
    
    <section class="main">
      <div class="">
        <div class="container-fluid min100vh">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-12 zindex100">
              <div class="row">
                <div class="col-12 col-lg-6 offset-lg-3 pb-3  text-center">
                  <h1 class="fXG rojo">Reportes</h1>
                </div>
              </div>

<div class="row">
                <div class="col-12 col-lg-6 offset-lg-3 pb-3  text-center">
                  <button @click="logout()" type="bitton" class="submit btn btnsup w-100 mx-auto">Cerrar Sesión</button>
                </div>
              </div>
              

              <div class="row pb-3">
                <div class="col-12 pt-2 pb-4">
                  <div class="row">
                    <div class="col-12  text-center fG bold py-3">Total de registros: {{total}}</div>
                    
                  </div>
                </div>
              </div>


              

              <div class="row pb-3">
                <div class="col-12 pt-2 pb-4">
                  <div class="row">
                    <div class="col-12 text-center py-3 fC" v-if="nombre_usuario != null">
                      <download-excel :data="this.data" name='Academia Coca Cola Accesos'>
                        <button class="btn btnsup">Exportar accesos a Excel</button>
                      </download-excel>
                    </div>
                  </div>

                  <v-client-table
                    :columns="columns"
                    v-model="data"
                    :options="options"
                    v-if="data != null"
                    class="fG"
                  >
                    <a
                      slot="uri"
                      slot-scope="props"
                      target="_blank"
                      :href="props.row.uri"
                      class="glyphicon glyphicon-eye-open"
                    ></a>

                    <!-- <div slot="child_row" slot-scope="props">
                      <a
                        class="pr-5"
                        target="_blank"
                        :href="baseurl+'uploads/'+props.row.img_qr"
                      >
                        <img
                          :src="baseurl+'uploads/'+props.row.img_qr"
                          alt="qr"
                          width="100"
                        />
                      </a>

                      <a
                        target="_blank"
                        :href="baseurl+'uploads/'+props.row.img_ticket"
                      >
                        <img
                          :src="baseurl+'uploads/'+props.row.img_ticket"
                          alt="qr"
                          width="100"
                        />
                      </a>
                    </div>-->

                    <div slot="name" slot-scope="{row, update, setEditing, isEditing, revertValue}">
                      <span @click="setEditing(true)" v-if="!isEditing()">
                        <a>{{row.name}}</a>
                      </span>
                      <span v-else>
                        <input type="text" v-model="row.name" />
                        <button
                          type="button"
                          class="btn btn-info btn-xs"
                          @click="update(row.name); setEditing(false)"
                        >Submit</button>
                        <button
                          type="button"
                          class="btn btn-default btn-xs"
                          @click="revertValue(); setEditing(false)"
                        >Cancel</button>
                      </span>
                    </div>
                  </v-client-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>


<style>
@import "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
</style>

<script>
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "../Components/Footer.vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import Vue from "vue";
Vue.use(ClientTable);



export default {
  name: "AcademiaDigital",
  props: {
    msg: String
  },
  data() {
    return {
      user: "",
      nombre_usuario: null,
      password: "",
      redirect_url: "",
      total: 0,
      confirmados: 0,
      cursos: null,
      columns: [
        "no_determinante",
        "timestamp",
        "semana"
      ],

      data: null,
      quizzes: null,
      options: {
        perPage: 100,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          id: "ID",
          timestamp: "Fecha Acceso"
        },
        editableColumns: ["name"],
        sortable: [
          "nombre",
          "apellido",
          "email",
          "telefono",
          "fecha_de_nacimiento",
          "estado",
          "codigo_de_verificacion",
          "confirmadotxt",
          "timestamp"
        ],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      },
      datos: [
        ['Fecha', 'No. de registros'],
      ],
      chartData: [
        ['Fecha', 'No. de registros'],
      ],
      chartOptions: {
        height: 560,
        title: "Registros diarios confirmados",
        subtitle: "Estos son los reportes diarios",
        legend: { position: "center" },
        bar: {groupWidth: "95%"},
        //colors: ["#954be7", "#e98cb5", "#1545ae", "#4ccbad"],
      },
    };
  },
  mounted: function() {
    console.log("useracademiadigitalreportes");

    this.$store.state.user_reportes = localStorage.getItem(
      "useracademiadigitalreportes"
    );
    this.nombre_usuario = JSON.parse(
      this.$store.state.user_reportes
    ).nombre_usuario;
    console.log(JSON.parse(this.$store.state.user_reportes).nombre_usuario);
    console.log(this.nombre_usuario);

    //this.cursos = this.$store.state.cursos;

    AOS.init();
    
    


    
    this.traeDatos();
  },
  components: {

    "footer-mx": Footer,

  },
  methods: {
    async createDataTable(chart,google) {


      await this.traeGrafica();

      var data = google.visualization.arrayToDataTable(this.datos);

      var view = new google.visualization.DataView(data);
      view.setColumns([0, 1,
          { calc: "stringify",
            sourceColumn: 1,
            type: "string",
            role: "annotation" }
      ]);

      //this.chartData = data;
      chart.draw(view, this.Options);
      
    },
    onChartReady (chart, google) {
      // now we have google lib loaded. Let's create data table based using it.
      this.createDataTable(chart,google);

    },
    async traeGrafica() {
      console.log("submit");
      var vm = this;

      const https = require("https");

      vm.$store.state.loading = true;

      console.log();

      var qData = {
        user: JSON.parse(this.$store.state.user_reportes).nombre_usuario
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      //console.log(JSON.stringify(qData));

      await this.$http
        .post(this.$store.state.baseurl + "reporte-grafico-confirmados.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              //this.$store.state.user = this.$cookie.get("useracademiadigital");

              for(var i = 0; i < res.users.length; i++){
                this.datos.push([res.users[i].order_day, res.users[i].cuenta])
              }
              
              //console.log(res.users);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");

              if (res.verificacion == 0) {
                this.$router.push("/verificacion/" + this.email);
              }
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    traeDatos() {
      console.log("submit");
      var vm = this;

      const https = require("https");

      vm.$store.state.loading = true;

      console.log();

      var qData = {
        user: JSON.parse(this.$store.state.user_reportes).nombre_usuario
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      //console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "reporte.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              //this.$store.state.user = this.$cookie.get("useracademiadigital");

              this.data = res.accesos;
              this.total = res.total;
             
              //console.log(res.users);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");

             
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    logout(){
      localStorage.removeItem('useracademiadigitalreportes');
      this.$router.push('/administrador')
    }
  }
};
</script>

